import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MenuElement } from '../../menu-element';

@Component({
    selector: 'adm4-menu-item-wrapper',
    template: `
    <div class='menu-element-inner'>
      @if (menuElement.useSvg) {
        <mat-icon [svgIcon]='menuElement.icon'
          [ngbTooltip]='menuElement.title' placement="right"
        ></mat-icon>
      } @else {
        <mat-icon [ngbTooltip]='menuElement.title' placement="right">{{menuElement.icon}}</mat-icon>
      }
      <span class="menu-text text-ellipsis">{{menuElement.title}}</span>
    </div>`,
    styleUrls: ['../../styles/component-specific/mat-menu.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MenuItemWrapperComponent {
  @Input() public menuElement: MenuElement;
}
